import TextField from '@mui/material/TextField'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import Button from '@mui/material/Button'
import {styled} from '@mui/material/styles'
import MenuItem from '@mui/material/MenuItem'
import Menu from '@mui/material/Menu'
import {Alert, Dialog, DialogActions, DialogContent, DialogTitle} from '@mui/material'
import ReportIcon from '@mui/icons-material/Report'

const StyledDialog = styled(Dialog)(() => ({
  '& .MuiDialog-paper': {
    padding: '8px'
  }
}))

const StyledDialogTitle = styled(DialogTitle)(() => ({
  padding: '16px 16px 0 16px',
  marginTop: '-2px'
}))

const StyledDialogContent = styled(DialogContent)(() => ({
  padding: '8px 16px',
  '& p': {
    margin: '8px 0'
  }
}))

const StyledDialogActions = styled(DialogActions)(() => ({
  padding: '8px 16px',
  marginBottom: 0,
  marginRight: 0,
  gap: '8px'
}))

const StyledAlert = styled(Alert)(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  backgroundColor: theme.palette.success.light,
  color: theme.palette.hpAccentBlack,
  padding: '8px 36px'
}))

const StyledMenu = styled(Menu)(() => ({
  '& .MuiMenu-paper': {
    marginLeft: '-30px',
    border: 'none'
  }
}))
const StyledMenuItem = styled(MenuItem)(({theme}) => ({
  fontSize: theme.typography.subtitle1.fontSize,
  color: theme.palette.text.primary,
  '&.create-new-event': {
    color: theme.palette.hpPrimaryDark
  },
  '&.edit-event-title': {
    color: theme.palette.hpPrimaryDark
  },
  '&.close-event': {
    color: theme.palette.error.main
  },
  '& svg': {
    marginRight: '8px',
    fontSize: '20px'
  }
}))

const StyledSpan = styled('span')(({theme}) => ({
  color: theme.palette.text.primary,
  fontSize: theme.typography.subtitle1.fontSize,
  '&.event-title': {
    marginRight: '10px'
  },
  '&.participant': {
    marginLeft: '10px',
    marginRight: '10px'
  }
}))

const StyledTextField = styled(TextField)(({theme}) => ({
  fontSize: theme.typography.subtitle2.fontSize,
  marginLeft: 'auto',
  marginRight: '10px',
  width: '200px',
  '& .MuiOutlinedInput-root': {
    height: '29px',
    fontSize: theme.typography.subtitle1.fontSize,
    '&.Mui-disabled': {
      backgroundColor: theme.palette.grey[100]
    }
  }
}))

const StyledInfoIcon = styled(InfoOutlinedIcon)(({theme}) => ({
  cursor: 'pointer',
  fontSize: theme.typography.h6.fontSize,
  color: theme.palette.hpPrimaryDark
}))

const StyledCancelButton = styled(Button)(({theme}) => ({
  backgroundColor: 'transparent',
  '&:hover': {
    backgroundColor: 'transparent',
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main
  }
}))

const StyledButton = styled(Button)(({theme}) => ({
  backgroundColor: theme.palette.info.main,
  color: theme.palette.grey[50],
  height: '30px',
  marginLeft: '8px',
  padding: '0 16px',
  fontSize: theme.typography.subtitle2.fontSize,
  border: '1px solid transparent',
  '&.end': {
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      backgroundColor: theme.palette.error.main,
      boxShadow: 'none'
    }
  },
  '&:hover': {
    backgroundColor: theme.palette.info.main,
    boxShadow: 'none',
    border: '1px solid transparent'
  }
}))

const StyledDialogButton = styled(Button)(({theme}) => ({
  border: '1px solid transparent',
  '&:hover': {
    backgroundColor: theme.palette.hpGreenVividDark,
    boxShadow: 'none',
    border: '1px solid transparent'
  }
}))

const StyledActionButton = styled(Button)(({theme}) => ({
  border: '1px solid transparent',
  letterSpacing: '0.3px',
  minWidth: '120px',
  height: '30px',
  '&:hover': {
    backgroundColor: theme.palette.primary.main,
    boxShadow: 'none',
    border: '1px solid transparent'
  }
}))

const StyledDisagreeButton = styled(Button)(({theme}) => ({
  backgroundColor: 'transparent',
  minWidth: '120px',
  letterSpacing: '0.3px',
  height: '30px',
  '&:hover': {
    backgroundColor: 'transparent',
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main
  }
}))

const StyledNote = styled('p')(({theme}) => ({
  padding: `${theme.spacing(1.5)} 0`
}))

const StyledCustomDialogActions = styled(DialogActions)(({theme}) => ({
  justifyContent: 'flex-start',
  padding: `${theme.spacing(1)} ${theme.spacing(2)}`
}))

const StyledErrorMessage = styled('span')(({theme}) => ({
  color: theme.palette.error.main,
  fontSize: theme.typography.subtitle2.fontSize,
  marginRight: '10px'
}))

const StyledReportIcon = styled(ReportIcon)(({theme}) => ({
  color: theme.palette.hpAccentOrange,
  marginRight: '8px', // Add spacing between the icon and the text
  verticalAlign: 'middle'
}))
export {
  StyledTextField,
  StyledInfoIcon,
  StyledButton,
  StyledErrorMessage,
  StyledSpan,
  StyledMenuItem,
  StyledAlert,
  StyledReportIcon,
  StyledDialog,
  StyledDialogButton,
  StyledDialogActions,
  StyledMenu,
  StyledDialogContent,
  StyledDialogTitle,
  StyledCancelButton,
  StyledNote,
  StyledCustomDialogActions,
  StyledActionButton,
  StyledDisagreeButton
}
